import gql from 'graphql-tag';

export const embeddedDokkioTagFragment = gql`
  fragment embeddedDokkioTagFragment on DokkioTag {
    dokkioClass
    accountID
    id
    dokkioLabelID
    name
    namePlural
    description
    logoID
    autoApplyConfidenceThreshold
    rowCreateMethod
    creatorDokkioUserID
    isGeneratingInitialSuggestions
    appliesToTypes
    blacklistNames
    synonyms
    dokkioTagIDs
    autoRulesEnabledAt
    lastDokkioViewAt
    rowCreatedAt
  }
`;
export default embeddedDokkioTagFragment;
